import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './presentation/fonts/fonts.css';
import App from './App';
import {
  initVkMiniAppShell,
  signalVkMiniAppReady,
} from './vk/bootstrapVkMiniApp';

const root = ReactDOM.createRoot(document.getElementById('root'));

async function bootstrap() {
  try {
    await initVkMiniAppShell();
  } catch {
    // Standalone browser or VK bridge unavailable — still render the app.
  }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  try {
    await signalVkMiniAppReady();
  } catch {
    // Non-fatal outside VK.
  }
}

bootstrap();
